import { NumberInputRow } from "./NumberInputRow"
import { SegmentedCountRow } from "./SegmentedCountRow"
import style from "./AttachmentsSection.module.scss"

const { section, sectionTitle } = style

const YES_NO_OPTIONS = [
	{ label: "Yes", value: "yes" as const },
	{ label: "No", value: "no" as const },
]

const COUNT_OPTIONS = [
	{ label: "0", value: 0 },
	{ label: "1", value: 1 },
	{ label: "2", value: 2 },
]

type Props = {
	adjustableShelves: number | null
	onAdjustableShelvesChange: (value: number | null) => void
	onAdjustableShelvesCommit: () => void
	hasLocks: "yes" | "no"
	onHasLocksChange: (value: "yes" | "no") => void
	fillings: number
	onFillingsChange: (value: number) => void
	finishingEnds: number
	onFinishingEndsChange: (value: number) => void
}

export const AttachmentsSection = ({
	adjustableShelves,
	onAdjustableShelvesChange,
	onAdjustableShelvesCommit,
	hasLocks,
	onHasLocksChange,
	fillings,
	onFillingsChange,
	finishingEnds,
	onFinishingEndsChange,
}: Props) => {
	return (
		<div className={section}>
			<p className={sectionTitle}>Attachments</p>
			<NumberInputRow
				label="Adjustable shelves"
				required
				value={adjustableShelves}
				onChange={onAdjustableShelvesChange}
				onBlur={onAdjustableShelvesCommit}
			/>
			<SegmentedCountRow
				label="Locks"
				required
				options={YES_NO_OPTIONS}
				value={hasLocks}
				onChange={onHasLocksChange}
			/>
			<SegmentedCountRow
				label="Fillers"
				options={COUNT_OPTIONS}
				value={fillings}
				onChange={onFillingsChange}
			/>
			<SegmentedCountRow
				label="Finishing ends"
				options={COUNT_OPTIONS}
				value={finishingEnds}
				onChange={onFinishingEndsChange}
			/>
		</div>
	)
}
